import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserdataService } from '../services/userdata.service';
import { UserService } from '../services/userservice.service';
import { Router } from '@angular/router';

import 'rxjs/add/operator/map';
import { collectExternalReferences } from '@angular/compiler';




@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  isDisplay = false;
  userdetails: any;

  userprofile = new FormGroup({
    name: new FormControl(''),
    email: new FormControl(''),
    phone: new FormControl(''),
    address: new FormControl(''),
    city: new FormControl(''),
    zip: new FormControl(''),
    state: new FormControl(''),
  });

  profile = new FormGroup({
    email: new FormControl(''),
    newpassword: new FormControl(''),
    oldpassword: new FormControl('')
  });

  email: any;
  username: any;
  mobilenumber: any;
  Password: any;
  newpassword: any;
  password: string;
  opassword: string;
  adservice: any;
  state: any;
  zip: any;
  address: any;
  city: any;
 




  constructor(private userdataservice: UserdataService, private router: Router,
              private userService: UserService, ) {

   }

  ngOnInit() {

    this.mobilenumber = this.userprofile.get('phone').value;
  //  this.email = this.userprofile.get('email').value;
    this.username = this.userprofile.get('name').value;
    this.state = this.userprofile.get('state').value;
    this.zip = this.userprofile.get('zip').value;
    this.city = this.userprofile.get('city').value;
    this.address = this.userprofile.get('address').value;
    console.log(this.userprofile.get('state').value)
    console.log(this.username, this.mobilenumber);

    const obj = this.userdataservice.getUserData();
    console.log(obj);
    this.state = obj.state;
    console.log(this.state)
    this.userprofile.patchValue({
      name: obj.username,
      email: obj.email,
      state: obj.state,
      zip: obj.zip,
      address: obj.address,
      city: obj.city,
      phone: obj.mobilenumber,
      newpassword: obj.password,
      oldpassword: obj.opassword,

    }
      // this.userdataService.getUserDataSubject().subscribe(data => {
      //   this.email = data['email'];
      // });

     );
    this.userdataservice.getUserDataSubject().subscribe(data => {
         this.email = data['email'];
       });



    }

  hideimage() {
    this.isDisplay = !this.isDisplay;
  }

  onSubmit() {
   this.mobilenumber = this.userprofile.get('phone').value;
   this.email = this.userprofile.get('email').value;
   this.username = this.userprofile.get('name').value;
   this.state = this.userprofile.get('state').value;
   this.zip = this.userprofile.get('zip').value;
   this.city = this.userprofile.get('city').value;
   this.address = this.userprofile.get('address').value;
   console.log(this.username, this.mobilenumber);

   this.userService.changeusername(this.email, this.username, this.mobilenumber, this.zip, this.city,  this.address, this.state)
      .subscribe(
        response => {
          console.log(response);
          if (response.status === 'Success') {
            const user = response.data;
            this.userdataservice.setUserData(user);
            window.alert('Successfully Changed');
          } else {
            window.alert('error in saving data');
          }
          // this.router.navigate(['/register']);
          //  this.userdataservice.setUserData(null);
          // this.adservice.setAdData(null);
          //  sessionStorage.clear();
        },
        error => console.log(error)
      );
  }

  nSubmit() {
    // this.email = this.profile.get('email').value;
    this.password = this.profile.get('newpassword').value;
    this.opassword = this.profile.get('oldpassword').value;
    console.log(this.email);
    console.log( this.password);
    console.log( this.opassword);
    this.userService.checkpassword(this.email, this.password).subscribe(
      data => {
        console.log(data);
      },
        error => console.log(error)
    );


    console.log( this.password);
    this.userService.resetpassword(this.email, this.password).subscribe(
    data => {
      console.log(data);
      window.alert('Successfully Updated');
      this.router.navigate(['/home']);
    },
      error =>
       console.log(error)
  );


  }
}


